import axios from "axios"

const apiUrl = "/api/quiz"

function buildOptions(options = {}) {
  const headers = { ...(options.headers || {}), Authorization: localStorage.getItem("token") }
  return { ...options, headers }
}

export default {
  liveQuiz: {
    fetchActiveSessions() {
      return axios.get(`${apiUrl}/live`, buildOptions()).then((response) => response.data)
    },

    fetchSessionByCode(code) {
      return axios.get(`${apiUrl}/live/${encodeURIComponent(code)}`, buildOptions()).then((response) => response.data)
    },

    manage: {
      fetchQuizzes(status = null) {
        const params = status ? { status } : {}
        return axios.get(`${apiUrl}/manage`, buildOptions({ params })).then((response) => response.data)
      },

      fetchQuiz(quizId) {
        return axios.get(`${apiUrl}/manage/${quizId}`, buildOptions()).then((response) => response.data)
      },

      createQuiz(payload) {
        return axios.post(`${apiUrl}/manage`, payload, buildOptions()).then((response) => response.data)
      },

      updateQuiz(quizId, payload) {
        return axios.put(`${apiUrl}/manage/${quizId}`, payload, buildOptions()).then((response) => response.data)
      },

      archiveQuiz(quizId) {
        return axios.delete(`${apiUrl}/manage/${quizId}`, buildOptions()).then((response) => response.data)
      },

      duplicateQuiz(quizId) {
        return axios.post(`${apiUrl}/manage/${quizId}/duplicate`, {}, buildOptions()).then((response) => response.data)
      },

      createSession(quizId, musicEnabled = true) {
        return axios.post(`${apiUrl}/manage/${quizId}/sessions`, { musicEnabled }, buildOptions()).then((response) => response.data)
      },

      fetchHistory() {
        return axios.get(`${apiUrl}/manage/history`, buildOptions()).then((response) => response.data)
      },

      fetchActiveSessions() {
        return axios.get(`${apiUrl}/manage/sessions/active`, buildOptions()).then((response) => response.data)
      },

      fetchResults(sessionId) {
        return axios.get(`${apiUrl}/manage/sessions/${sessionId}/results`, buildOptions()).then((response) => response.data)
      },
    },
  },
}
